/**
 * Port of `app/logoutUsers/logoutUsersEnum.js` (AngularJS constant
 * `LogoutUsersEnum`) — the tenant status codes the "Logout de usuários por
 * status do tenant" screen sends to the session-invalidator endpoint.
 *
 * Values are kept as numbers (not strings) matching the legacy constant;
 * the legacy `<select>` serialized them to strings via interpolation
 * (`{{LogoutUsersEnum.TRIAL}}`) and the controller parsed them back with
 * `parseInt(...)` before sending — `LogoutUsersPage.jsx` follows the same
 * round-trip (MUI `Select` option values are strings) for parity.
 */
export const LogoutUsersEnum = {
  TRIAL: 0,
  ATIVO: 1,
  SUSPENSO: 2,
  CANCELADO: 3,
  CORTESIA: 4,
  AGUARDANDO_REGISTRO: 5,
  EXPIRADO: 6,
  TODOS: 7,
}

export default LogoutUsersEnum
